import { baseApi } from "@/redux/api/baseApi";
import { TQueryParam } from "../user/userApi";

const balanceWithdrawApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWithDrawRequests: builder.query({
      query: (args) => {
        const params = new URLSearchParams();
        if (args) {
          args.forEach((element: TQueryParam) => {
            params.append(element.name, element.value as string);
          });
        }

        return {
          url: "/creator-payment-withdraw/creator",
          method: "GET",
          params: params,
        };
      },
      providesTags: ["WithdrawnRequest"],
    }),

    submitWithDrawReq: builder.mutation({
      query: (payload) => ({
        url: `/creator-payment-withdraw/submit`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["WithdrawnRequest"],
    }),
  }),
});

export const { useGetWithDrawRequestsQuery, useSubmitWithDrawReqMutation } =
  balanceWithdrawApi;
